import { useDispatch } from "react-redux";

export default function useRemoveLocationFromSearch() {
    const dispatch = useDispatch()

    return (location) => {
        dispatch({
            type: 'REMOVE_LOCATION_SEARCH',
            item: {name: location}
        })
    }
}
